<template>
	<div class="project-toggler dropdown" v-if="myProjects && myProjects.length > 1">
		<b-dropdown variant="outline-secondary" size="sm" :text="myProject ? myProject.titre : ''" v-click-outside="handleOutside">
			<div class="content-search" v-if="isSearch">
				<div class="input-search-grouping">
					<b-form-input
						ref="searchInput"
						id="input-search"
						v-model="searchText"
						:placeholder="FormMSG(3, 'Type to search ...')"
						@keydown.stop
						@click.stop
					></b-form-input>
					<div class="clear">
						<component :is="getLucideIcon(ICONS.X.name)" :color="ICONS.X.color" :size="22" @click.prevent.stop="handleActionSearch()" />
					</div>
				</div>
			</div>
			<b-dropdown-header v-if="!isSearch" id="dropdown-header-label">
				<div class="d-flex flex-row w-100">
					<div class="d-flex align-items-center justify-content-start flex-grow-1">{{ this.FormMSG(1, 'Switch to another project') }}</div>
					<div class="d-flex align-items-center justify-content-end flex-grow-0">
						<b-button variant="light" class="mt-1" @click.prevent.stop="handleActionSearch()">
							<component :is="getLucideIcon(ICONS.SEARCH.name)" :color="ICONS.PLUS_CIRCLE.color" :size="22" />
						</b-button>
					</div>
				</div>
			</b-dropdown-header>
			<template v-if="filteredProjects.length">
				<b-dropdown-item-button
					v-for="project in filteredProjects"
					:key="project.id"
					@click="selectProject(project)"
					:active="myProject && myProject.id === project.id"
				>
					{{ project.titre }}
				</b-dropdown-item-button>
			</template>
			<b-dropdown-item-button v-else disabled class="text-muted"> {{ FormMSG(2, 'No matching project') }} </b-dropdown-item-button>
		</b-dropdown>
	</div>
	<div class="project-toggler" v-else>
		<span class="label-only">{{ myProject ? myProject.titre : '' }}</span>
	</div>
</template>

<script>
import { store } from '@/store';
import { myContracts } from '@/cruds/contract.crud';
import languageMessages from '@/mixins/languageMessages';
// import { getParamVersion } from '@/shared/version';
import { mapActions } from 'vuex';
import globalMixin from '@/mixins/global.mixin';
import { myListOfProjects as renderMyListOfProjects, myProject as renderMyProject, changeProject as renderChangeProject } from '@/cruds/project.crud';

export default {
	name: 'HeaderProjectToggler',
	mixins: [languageMessages, globalMixin],
	data: function () {
		return {
			erreur: {},
			myerr: '',
			shared: store.state,
			isSearch: false,
			searchText: '',
			myProjects: [],
			myProject: []
		};
	},
	computed: {
		filteredProjects() {
			const s = this.searchText.toLowerCase();
			return this.myProjects.filter((p) => p.titre.toLowerCase().includes(s));
		}
	},
	async mounted() {
		await this.getListOfMyProjects();
		await this.getMyProject();
	},
	methods: {
		...mapActions({
			getNotifications: 'header/getNotifications',
			initFilterActive: 'global-filter/initFilterActive',
			getDocuments: 'document/getDocuments'
		}),
		async selectProject(project) {
			this.myProject = project;
			await this.changeProject(project);
		},
		async getListOfMyProjects() {
			const listOfMyProjects = await renderMyListOfProjects();
			if (listOfMyProjects) {
				this.myProjects = listOfMyProjects;
			}
		},
		async getMyProject() {
			const myProject = await renderMyProject();
			if (myProject) {
				this.myProject = myProject;
			}
		},
		handleActionSearch() {
			this.isSearch = !this.isSearch;
			this.searchText = '';
			if (this.isSearch) {
				this.$nextTick(() => {
					const searchInputRef = this.$refs.searchInput;
					if (searchInputRef) {
						searchInputRef.focus();
					}
				});
			}
		},
		handleOutside() {
			this.isSearch = false;
			this.searchText = '';
		},
		async changeProject(project) {
			const id = parseInt(project.id, 10);
			const newToken = await renderChangeProject(id);
			if (newToken) {
				const updateStoreToken = await store.onNewToken(this.$apollo.provider.defaultClient, newToken);
				if (updateStoreToken) {
					const updateCurrentProject = await store.setProjectAction(project);
					if (updateCurrentProject) {
						this.initFilterActive();
						const tmp = await myContracts();
						store.state.myContracts = tmp;
						this.myerr = '';
						this.$router.push('/my-dashboard' /*+ getParamVersion()*/).catch(() => {});
						await this.getNotifications(project.id);
						this.getDocuments({
							userId: +store.userID()
						});
					}
				}
			}
		}
	}
};
</script>
<style scoped lang="scss">
::v-deep .dropdown-menu {
	max-height: 650px;
	overflow-y: auto;
}
.project-toggler .dropdown-menu {
	margin: 0;
	padding: 0;
}

.project-toggler .label-only {
	color: #007949;
	font-weight: bold;
	display: inline-block;
	background-color: #eee;
	border: 1px solid #eee;
	padding: 0.25rem 0.5rem;
	font-size: 0.875rem;
	line-height: 1.5;
	border-radius: 0.2rem;
}
</style>
<style lang="scss">
%size-bar {
	width: 5px;
}
.project-toggler {
	.content-search {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 2px;
		.input-search-grouping {
			display: flex;
			position: relative;
			width: 100%;
			align-items: center;
			justify-content: end;
			#input-search {
				height: 40px !important;
			}
			.clear {
				display: flex;
				align-items: center;
				justify-content: center;
				position: absolute;
				height: 38px !important;
				width: 30px;
				background-color: transparent;
				cursor: pointer;
				svg {
					stroke: #ccc;
					&:hover {
						stroke: #e53935;
					}
				}
			}
		}
	}
	ul {
		overflow: auto;
		width: 300px;
		&::-webkit-scrollbar-thumb {
			@extend %size-bar;
			background-color: #333;
		}
		&::-webkit-scrollbar-track {
			background-color: #ffffff;
		}
		&::-webkit-scrollbar {
			@extend %size-bar;
		}
	}
}
</style>
